import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { Checkbox, Text, theme } from 'ui_2';
import { getEmojiFlag, TCountryCode, getCountryData } from 'countries-list';
import { BiErrorCircle } from 'react-icons/bi';

const RegionUnavailabilityBadge = ({
  countryCode,
}: {
  countryCode?: string;
}) => {
  if (countryCode === 'global') return undefined;
  return (
    <div className='inline-flex items-center gap-1.5 rounded-[10px] bg-red-50 px-2.5 py-1 text-xs font-medium text-red-700 dark:bg-red-900/30 dark:text-red-400'>
      <BiErrorCircle color={theme.colors.red[600]} rotate={180} size={16} />
      <Text font='sm' color={'red'}>
        This item is unavailable in{' '}
        {countryCode
          ? `${getCountryData(countryCode as TCountryCode).name} ${getEmojiFlag(
              countryCode as TCountryCode
            )}`
          : 'your region'}
      </Text>
    </div>
  );
};

type AvailabilityCheckboxProps = {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  availableInUserCountry?: boolean;
};
export const AvailabilityCheckbox = ({
  checked,
  setChecked,
  availableInUserCountry,
}: AvailabilityCheckboxProps) => {
  const { countryCode } = useArcadeStoreState();

  return (
    <div className='flex flex-col gap-2'>
      {availableInUserCountry === false && (
        <RegionUnavailabilityBadge countryCode={countryCode} />
      )}
      <div className='flex items-start space-x-2'>
        <Checkbox
          id='terms'
          checked={checked}
          onCheckedChange={(value) => setChecked(!!value)}
          className='mt-0.5'
        />
        <label
          htmlFor='terms'
          className='peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
        >
          <Text font='sm'>
            {availableInUserCountry === false
              ? `I acknowledge this item is unavailable in ${
                  countryCode && countryCode !== 'global'
                    ? `${
                        getCountryData(countryCode as TCountryCode).name
                      } ${getEmojiFlag(countryCode as TCountryCode)}`
                    : 'my region'
                }`
              : 'I confirm this item is available in my region'}
          </Text>
        </label>
      </div>
    </div>
  );
};
